//jsxhook

import { H6, Row, SimpleSrcSet } from "@sixty-six-north/ui-system"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
import { useApplePay, usePayPal } from "FeatureFlags"
import React, { ReactNode } from "react"

export const AcceptedCreditAndDebitCards: React.FC = () => {
  const applePay = useApplePay()
  const payPal = usePayPal()
  const { t } = useTranslation("checkout")

  return (
    <React.Fragment>
      <Box sx={{ marginBottom: 16 }}>
        <H6 sx={{ color: "black.1" }}>
          {t("acceptedCreditAndDebitCards", {
            defaultValue: "Accepted credit & debit cards"
          })}
        </H6>
      </Box>
      <Row sx={{ justifyContent: "flex-start", flexWrap: "wrap" }}>
        <PaymentBox>
          <SimpleSrcSet src="48856" title={"Visa"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="48854" title={"Mastercard"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="48858" title={"American Express"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="48853" title={"Maestro"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="48857" title={"Discover"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="48855" title={"JCB"} width={36} />
        </PaymentBox>
        <PaymentBox>
          <SimpleSrcSet src="85853" title={"Google Pay"} width={36} />
        </PaymentBox>
        {applePay && (
          <PaymentBox>
            <SimpleSrcSet src="52617" title={"Apple Pay"} width={36} />
          </PaymentBox>
        )}
        {payPal && (
          <PaymentBox>
            <SimpleSrcSet src="52616" title={"PayPal"} width={36} />
          </PaymentBox>
        )}
      </Row>
    </React.Fragment>
  )
}

const PaymentBox: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={{
        mr: 12,
        "& > img": { width: 36 },

        "& > svg": { width: 36 }
      }}
    >
      {children}
    </Box>
  )
}
